import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M31.824 35.68a1.753 1.753 0 0 1-2.112 1.272 1.738 1.738 0 0 1-1.305-1.335l-4.404-21.893-4.427 18.505a1.75 1.75 0 0 1-2.102 1.286 1.742 1.742 0 0 1-1.298-1.256l-3.541-14.206-2.269 6.054A2.623 2.623 0 0 1 7.9 25.81H3.875A.869.869 0 0 1 3 24.947c0-.476.392-.862.875-.862h4.024a.876.876 0 0 0 .824-.57l2.267-6.05a1.74 1.74 0 0 1 1.204-1.08c.935-.24 1.89.313 2.137 1.246l3.541 14.205L22.3 13.332a1.738 1.738 0 0 1 1.352-1.296 1.75 1.75 0 0 1 2.067 1.347l4.404 21.892 3.56-15.919c.127-.52.493-.954.99-1.171.884-.387 1.918.005 2.297.848l2.244 4.54c.14.312.453.512.8.512h4.112c.483 0 .875.386.875.862a.869.869 0 0 1-.875.862h-4.113c-1.037 0-1.977-.602-2.386-1.508l-2.243-4.54-3.56 15.918Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSoundwaveOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundwaveOutlined_default = SvgSoundwaveOutlined;

export { SoundwaveOutlined_default as default };
